import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FiltrarData, InputMes, LinksPaginas, OpcoesFiltragem, PaginasTabela, SecaoAdmin, SecaoPrincipal } from "../AdminStyled";
import { listarSessoes } from "../../../servicos/sessoesServices";
import { TabelaSessoes } from "./TabelaSessoes";
import { IoMdRefresh } from "react-icons/io";
import CabecalhoAdmin from "../../../componentes/CabecalhoAdmin";
import MenuLateral from "../../../componentes/MenuLateral";
import ErroSpan from "../../../componentes/ErroSpan";

export default function Sessoes(){
    const [params, setParams] = useSearchParams();
    const [sessoes, setSessoes] = useState([]);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [carregando, setCarregando] = useState(false);
    const [datas, setDatas] = useState({ dataInicial: params.get("dataInicial"), dataFinal: params.get("dataFinal") });

    useEffect( () => {
        obterSessoes(params.get("pagina"), params.get("ordem"), params.get("ordenacao"), params.get("dataInicial"), params.get("dataFinal"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.get("pagina"), params.get("ordem"), params.get("ordenacao"), params.get("dataInicial"), params.get("dataFinal")]);

    async function obterSessoes(pagina, ordem, ordenacao, dataIni, dataFim){
        setCarregando(true);
        listarSessoes(pagina, ordem, ordenacao, {dataInicial: dataIni, dataFinal: dataFim}).then( resposta => {
            setCarregando(false);
            if (resposta.dados) {
                setSessoes(resposta.dados);
                setTotalPaginas(Math.ceil(resposta.totalDocs/20));
            }
        });
    }
    
    // Função para atualizar os parametros de data da URL
    function atualizarDatas() {
        let dataIni = datas.dataInicial;
        let dataFim = datas.dataFinal;

        if (!dataIni) dataIni = "";
        if (!dataFim) dataFim = "";

        setParams(params => {
            params.set("dataInicial", dataIni);
            params.set("dataFinal", dataFim);
            params.set("pagina", 1);
            return params;
        });
    }

    // Função para atualizar um parametro da URL
    function atualizarParametro(parametro, valor) {
        if (!valor) valor = "";

        setParams(params => {
            params.set(parametro, valor);
            return params;
        });
    }
    
    return (
        <SecaoAdmin>
            <MenuLateral />
            <SecaoPrincipal>
                {CabecalhoAdmin("Sessões")}
                <OpcoesFiltragem $margem="15px 0 15px 40px">
                    <FiltrarData $marginTop="1px">
                        <label>Data inicial</label>
                        <InputMes type="date" defaultValue={datas.dataInicial} onChange={event => setDatas({...datas, dataInicial: event.target.value})}/>
                    </FiltrarData>
                    <FiltrarData $marginTop="1px">
                        <label>Data final</label>
                        <InputMes type="date" defaultValue={datas.dataFinal} onChange={event => setDatas({...datas, dataFinal: event.target.value})}/>
                    </FiltrarData>
                    <IoMdRefresh className="Icone" onClick={() => atualizarDatas()}/>
                </OpcoesFiltragem>
                {((!sessoes || sessoes.length === 0 || carregando) && <ErroSpan $corFundo="transparent" $corTexto="#252525">Carregando...</ErroSpan>) || <>
                    {TabelaSessoes(sessoes, params, atualizarParametro)}
                    <PaginasTabela>
                        <p onClick={() => atualizarParametro("pagina", 1)}>Primeira</p>
                        <p onClick={() => {
                            if (parseInt(params.get("pagina")) > 1){
                                atualizarParametro("pagina", parseInt(params.get("pagina")) - 1)}
                            }
                        }>Anterior</p>
                        {paginas()}
                        <p onClick={() => atualizarParametro("pagina", parseInt(params.get("pagina")) + 1)}>Próxima</p>
                        <p onClick={() => atualizarParametro("pagina", totalPaginas)}>Última</p>
                    </PaginasTabela>
                </>}
            </SecaoPrincipal>
        </SecaoAdmin>
    );

    function paginas() {
        let pages = [];
        let ajuste = 2;
    
        if (parseInt(params.get("pagina")) === 1){
            ajuste = 0;
        } else if (parseInt(params.get("pagina")) === 2){
            ajuste = 1;
        } else if (parseInt(params.get("pagina")) === totalPaginas-1 && totalPaginas > 4){
            ajuste = 3;
        } else if (parseInt(params.get("pagina")) === totalPaginas && totalPaginas > 4){
            ajuste = 4;
        }
        if (totalPaginas < 5){
            for (let i = 0; i < totalPaginas; i++){
                let pageNum = parseInt(i + 1);
    
                if (pageNum === parseInt(params.get("pagina"))) {
                    pages.push(<LinksPaginas key = {`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                }else {
                    pages.push(<LinksPaginas 
                        key = {`page${pageNum}`}
                        id={pageNum} 
                        onClick={event => atualizarParametro("pagina", parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        } else {
            for (let i = 0; i < 5; i++){
    
                let pageNum = parseInt(params.get("pagina")) + parseInt(i) - ajuste;
    
                if (pageNum === parseInt(params.get("pagina"))) {
                    pages.push(<LinksPaginas key = {`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                }else {
                    pages.push(<LinksPaginas 
                        key = {`page${pageNum}`}
                        id={pageNum} 
                        onClick={event => atualizarParametro("pagina", parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        }    
        return pages;
    }
}
